import React from "react";
import { NavLink } from "react-router-dom";
import './styles.css';
function SubTabsGeneralParams() {
    return (
      <div className="scrollable-container-app">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <NavLink to="/generalparams/regions" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Regions
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/generalparams/suppliers" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Suppliers
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/generalparams/warehouses" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Warehouses
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/generalparams/containers" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Containers
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/generalparams/containers-type" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Container Types
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/generalparams/applications" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Applications
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/generalparams/products-label" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Product Labels
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/generalparams/items-type" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Item Types
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/generalparams/costgrid-lots" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Costgrid Lots
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/generalparams/costgrid-subtasks" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Costgrid Subtasks
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/generalparams/costgrid-uom" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Costgrid UOM
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/generalparams/costgrid-filter" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Costgrid Filter
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/generalparams/costgrid-transferts-filter" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Transferts Costgrid Filter
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/generalparams/purchases-type" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Purchase Types
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/generalparams/fiscal-years" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Fiscal Years
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/generalparams/palletpodelay" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Pallet PoDelay
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/generalparams/transfertpodelay" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Transfert PoDelay
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/generalparams/users" className="nav-link" activeClassName="active" 
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Users
            </NavLink>
          </li>
        </ul>
      </div>
    );
  }
  
  export default SubTabsGeneralParams;